import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language resources
import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enNavigation from './en/navigation.json';
import enPages from './en/pages.json';

import zhCNCommon from './zh-CN/common.json';
import zhCNAuth from './zh-CN/auth.json';
import zhCNNavigation from './zh-CN/navigation.json';
import zhCNPages from './zh-CN/pages.json';

import zhTWCommon from './zh-TW/common.json';
import zhTWAuth from './zh-TW/auth.json';
import zhTWNavigation from './zh-TW/navigation.json';
import zhTWPages from './zh-TW/pages.json';

import jaCommon from './ja/common.json';
import jaAuth from './ja/auth.json';
import jaNavigation from './ja/navigation.json';
import jaPages from './ja/pages.json';

// Language resources configuration
const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    navigation: enNavigation,
    pages: enPages,
  },
  'zh-CN': {
    common: zhCNCommon,
    auth: zhCNAuth,
    navigation: zhCNNavigation,
    pages: zhCNPages,
  },
  'zh-TW': {
    common: zhTWCommon,
    auth: zhTWAuth,
    navigation: zhTWNavigation,
    pages: zhTWPages,
  },
  ja: {
    common: jaCommon,
    auth: jaAuth,
    navigation: jaNavigation,
    pages: jaPages,
  },
};

// Get saved language from localStorage or default to English
const getStoredLanguage = (): string => {
  try {
    return localStorage.getItem('admin-language') || 'en';
  } catch {
    return 'en';
  }
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage(),
    fallbackLng: 'en',
    // 使用 Vite 提供的环境变量：在开发模式启用 i18n 调试日志
    debug: import.meta.env.DEV,
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'auth', 'navigation', 'pages'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // React specific options
    react: {
      useSuspense: false,
    },
  });

// Save language preference to localStorage when changed
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('admin-language', lng);
  } catch (error) {
    console.warn('Failed to save language preference:', error);
  }
});

export default i18n;